window.Cookies = require('js-cookie');
require("html5shiv");
window.SwipeListener = require('swipe-listener');

var _dateFormat = require('date-fns/format')
var _dateLocales = {
	fr:require('date-fns/locale/fr'),
	de:require('date-fns/locale/de'),
	it:require('date-fns/locale/it'),
	es:require('date-fns/locale/es'),
	nl:require('date-fns/locale/nl'),
	ru:require('date-fns/locale/ru'),
	ja:require('date-fns/locale/ja'),
	pt:require('date-fns/locale/pt'),
};
window.dateFormat = function(date, formatStr)
{
	return _dateFormat(date, formatStr, {
		locale: _dateLocales[window.ENV_LNG]
	})
}


// --------------------------------------------------------------------

require('jquery-ui/themes/base/all.css');

// require("jquery-ui/ui/core.js"); // deprecated script
// replace by the following script
require("jquery-ui/ui/version.js");
require("jquery-ui/ui/data");
require("jquery-ui/ui/disable-selection");
require("jquery-ui/ui/focusable");
require("jquery-ui/ui/form");
require("jquery-ui/ui/keycode");
require("jquery-ui/ui/labels");
require("jquery-ui/ui/jquery-patch.js");
require("jquery-ui/ui/plugin");
require("jquery-ui/ui/safe-active-element");
require("jquery-ui/ui/safe-blur");
require("jquery-ui/ui/scroll-parent");
require("jquery-ui/ui/tabbable");
require("jquery-ui/ui/unique-id");
require("jquery-ui/ui/position.js");

// jQuery UI widgets
require("jquery-ui/ui/widget.js");
require("jquery-ui/ui/widgets/accordion.js");
require("jquery-ui/ui/widgets/datepicker.js");
require("jquery-ui/ui/widgets/tabs.js");
//require("jquery-ui/ui/widgets/mouse.js");
//require("jquery-ui/ui/widgets/draggable.js");
//require("jquery-ui/ui/widgets/droppable.js");
//require("jquery-ui/ui/widgets/resizable.js");
//require("jquery-ui/ui/widgets/selectable.js");
//require("jquery-ui/ui/widgets/sortable.js");
//require("jquery-ui/ui/widgets/autocomplete.js");
//require("jquery-ui/ui/widgets/button.js");
//require("jquery-ui/ui/widgets/dialog.js");
//require("jquery-ui/ui/widgets/menu.js");
//require("jquery-ui/ui/widgets/progressbar.js");
//require("jquery-ui/ui/widgets/slider.js");
//require("jquery-ui/ui/widgets/spinner.js");
//require("jquery-ui/ui/widgets/tooltip.js");

// jQuery UI Effects
require("jquery-ui/ui/effect.js");

// --------------------------------------------------------------------

// Add Here additionnal datepicker language if needed
require("jquery-ui/ui/i18n/datepicker-de.js");
require("jquery-ui/ui/i18n/datepicker-it.js");
require("jquery-ui/ui/i18n/datepicker-es.js");
require("jquery-ui/ui/i18n/datepicker-pt.js");
require("jquery-ui/ui/i18n/datepicker-ru.js");
require("jquery-ui/ui/i18n/datepicker-ja.js");
require("jquery-ui/ui/i18n/datepicker-en-GB.js");
require("jquery-ui/ui/i18n/datepicker-nl.js");
require("jquery-ui/ui/i18n/datepicker-fr.js");

require("jquery-datetimepicker");
require("jquery-datetimepicker/build/jquery.datetimepicker.min.css");

var language = $('body').attr('lang');
if(language=='en')
	language = 'en-GB';
else if(language=='jp')
	language = 'ja';

if($.datepicker.regional[language])
	$.datepicker.setDefaults( $.datepicker.regional[language] );
else
	$.datepicker.setDefaults( $.datepicker.regional['en-GB'] );

$( document ).ready(function() {
	$(".datepicker").datepicker({
		dateFormat: 'dd/mm/yy',
		minDate: 0,
		beforeShow: function() {
			setTimeout(function(){
				$('.ui-datepicker').css('z-index', 99999999999999);
			}, 0);
		}
	});
});